import { IMicrosoftAuthMutations } from './mutations.types';

export const mutations: IMicrosoftAuthMutations = {};
